import textStyle from './title.textStyle'
import subtextStyle from './title.subtextStyle'

export default {
  name: "title",
  nickname: "标题",
  desc: "title",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示标题组件。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    text: {
      name: "text",
      nickname: "文本",
      desc: '主标题文本，支持使用 <code class="codespan">\\n</code> 换行。',
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    link: {
      name: "link",
      nickname: "链接",
      desc: "主标题文本超链接。",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    target: {
      name: "target",
      nickname: "目标类型",
      desc: "指定窗口打开主标题超链接。",
      value: "blank",
      defaultValue: "blank",
      type: "pureValue",
    },
    textStyle,
    subtext: {
      name: "subtext",
      nickname: "副标题",
      desc: '副标题文本，支持使用 <code class="codespan">\\n</code> 换行。',
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    sublink: {
      name: "sublink",
      nickname: "副标题超链接",
      desc: "副标题文本超链接。",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
    subtarget: {
      name: "subtarget",
      nickname: "副标题链接目标类型",
      desc: "指定窗口打开副标题超链接，可选：",
      value: "blank",
      defaultValue: "blank",
      type: "pureValue",
    },
    subtextStyle,
    textAlign: {
      name: "textAlign",
      nickname: "文本对齐",
      desc: "整体（包括 text 和 subtext）的水平对齐。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    textVerticalAlign: {
      name: "textVerticalAlign",
      nickname: "文本垂直对齐",
      desc: "整体（包括 text 和 subtext）的垂直对齐。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    triggerEvent: {
      name: "triggerEvent",
      nickname: "是否触发事件",
      desc: "是否触发事件。",
      value: false,
      defaultValue: false,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        "标题内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    itemGap: {
      name: "itemGap",
      nickname: "间距",
      desc: "主副标题之间的间距。",
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
    zlevel: {
      name: "zlevel",
      nickname: "图形z水平",
      desc: "所有图形的 zlevel 值。",
      value: 0,
      defaultValue: 0,
    },
    z: {
      name: "z",
      nickname: "z",
      desc:
        '组件的所有图形的<code class="codespan">z</code>值。控制图形的前后顺序。<code class="codespan">z</code>值小的图形会被<code class="codespan">z</code>值大的图形覆盖。',
      value: 2,
      defaultValue: 2,
      type: "pureValue",
    },
    left: {
      name: "left",
      nickname: "位置左",
      desc: "title 组件离容器左侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    top: {
      name: "top",
      nickname: "位置上",
      desc: "title 组件离容器上侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    right: {
      name: "right",
      nickname: "位置右",
      desc: "title 组件离容器右侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    bottom: {
      name: "bottom",
      nickname: "位置下",
      desc: "title 组件离容器下侧的距离。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "标题背景色，默认透明。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "标题的边框颜色。支持的颜色格式同 backgroundColor。",
      value: "#ccc",
      defaultValue: "#ccc",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "标题的边框线宽。",
      value: 0,
      defaultValue: 0,
    },
    borderRadius: {
      name: "borderRadius",
      nickname: "边框圆角",
      desc: "",
      value: 0,
      defaultValue: 0,
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "BT",
}
